import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Box, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { yupResolver } from "@hookform/resolvers/yup";
import { numeroActaSchema, onSubmitBuscarRecibo } from "./handlers";
import TextInput from "../../components/ReactHookForm/TextInput";
import MuniSpinner from "../../components/MuniSpinner";

const FormPagar = ({ numero_acta_autocomplete, documento_titular_autocomplete, setRecibo }) => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: 'all',
    defaultValues: {
      numero_acta: numero_acta_autocomplete ?? '',
      documento_titular: documento_titular_autocomplete ?? '',
    },
    resolver: yupResolver(numeroActaSchema),
  });

  const actaEsMVD = watch('numero_acta')?.trim().split('-')[0].toUpperCase() === 'MVD';

  useEffect(() => {
    if (!actaEsMVD){
      reset({documento_titular: ''})
    }
  }, [actaEsMVD, reset])

  return (
    <Box className='mt-4'>
      <Form onSubmit={handleSubmit((data) => onSubmitBuscarRecibo(data, setRecibo, setIsLoading))}>
        <fieldset disabled={isLoading}>
          <Box className='d-flex flex-column' sx={{ width: "100%" }}>
            <Box>
              <TextInput name='numero_acta' label='Numero de Acta *' register={register} errors={errors?.numero_acta} />
            </Box>
            {actaEsMVD && (
              <TextInput name='documento_titular' label='Documento / CUIT *' register={register} errors={errors?.documento_titular} />
            )}
            <Button size="lg" type='submit' disabled={isLoading} style={{ marginBottom: errors?.numero_acta ? "28px" : "16px", }}>
              {isLoading ? (
                <Box className='w-full h-full'>
                  <MuniSpinner
                    width="24px"
                    height="24px"
                    circularProgressSize={30}
                    circularProgressColor="#ffffff"
                    fileName="bola-blanca.png"
                  />
                </Box>
              ) : (
                <SearchIcon/>
              )}
            </Button>
          </Box>
        </fieldset>

        <div className='alert alert-primary' role='alert'>
          <Typography className='mb-1'>El formato del acta debe ser una de las siguientes opciones: </Typography>
          <ul style={{ marginBottom: "0" }}>
            <li>DTP-999999</li>
            <li>DTM-999999</li>
            <li>MVD-999999</li>
          </ul>
        </div>
      </Form>
    </Box>
  );
};

export default FormPagar;
